import { Spinner } from '@space-core/components/spinner'
import { useParentInfoStore } from '@space-shell/remotes/preview/store/parentInfo'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const MessageContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
`

const Message = styled.div`
  border: 0.063rem solid var(--gray-300);
  box-shadow: 0 1rem 2.5rem -0.5rem #0000001f;
`

const LoadingMessage = () => {
  const { t } = useTranslation()
  const { progressBanner: progress } = useParentInfoStore()

  return (
    <MessageContainer className='_w-full _h-full _d-flex _position-absolute _justify-content-center _align-items-center'>
      <Message className='_bg-primary _rounded _px-4 _py-3 _d-flex _justify-content-center _align-items-center'>
        <Spinner size='1rem' borderSize='0.125rem' className='_mr-4' />
        <p className='_m-0 _text-gray-900 _text-1 _font-weight-bold'>
          {t('preview.banner.loading_file', { progress })}
        </p>
      </Message>
    </MessageContainer>
  )
}

export default LoadingMessage
